import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight, Clock } from 'lucide-react';
export function ExitReminderPopup() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = (scrollTop + winHeight) / docHeight;
      // Trigger when user is within 5% of the bottom
      if (scrollPercent > 0.95 && !dismissed) {
        setShow(true);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [dismissed]);
  const handleDismiss = () => {
    setShow(false);
    setDismissed(true);
  };
  const handleGoToOffer = () => {
    setShow(false);
    setDismissed(true);
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Ingresos Digitales Atómicos',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    window.open('https://www.simplementemejor.com/cart/51696108929304:1', '_blank');
  };
  return <AnimatePresence data-id="element-23">
      {show && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} onClick={handleDismiss} className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm" data-id="element-24" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 350
      }} className="fixed inset-0 z-[61] flex items-center justify-center px-4" data-id="element-25">
            <div className="luxury-border max-w-md w-full relative overflow-hidden" data-id="element-26">
              {/* Glow */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-24 bg-[#14b8a6] blur-[80px] opacity-[0.08]" data-id="element-27" />

              {/* Close */}
              <button onClick={handleDismiss} className="absolute top-4 right-4 z-10 text-gray-500 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-28">
                <X size={20} data-id="element-29" />
              </button>

              <div className="p-8 md:p-10 text-center relative z-10" data-id="element-30">
                {/* Icon */}
                <div className="w-14 h-14 rounded-2xl bg-[#14b8a6]/10 border border-[#14b8a6]/20 flex items-center justify-center mx-auto mb-6" data-id="element-31">
                  <Clock size={24} className="text-[#14b8a6]" data-id="element-32" />
                </div>

                <h3 className="text-2xl md:text-3xl font-black text-white mb-3 leading-tight" data-id="element-33">
                  ¡Espera! Tu oferta sigue activa
                </h3>

                <p className="text-gray-400 mb-2 leading-relaxed" data-id="element-34">
                  El precio de lanzamiento de{' '}
                  <span className="text-white font-bold" data-id="element-35">$6.39 USD</span> no
                  estará disponible por mucho tiempo.
                </p>

                <p className="text-[#14b8a6] text-sm font-semibold mb-8" data-id="element-36">
                  No pierdas la oportunidad de transformar tus redes en ingresos
                  reales.
                </p>

                <div className="luxury-divider mb-8" data-id="element-37" />

                <button onClick={handleGoToOffer} className="w-full relative overflow-hidden bg-gradient-to-r from-[#14b8a6] via-[#2dd4bf] to-[#14b8a6] bg-[length:200%_100%] text-black font-black tracking-wide btn-shimmer btn-pulse-glow border border-[#2dd4bf]/20 shadow-[0_4px_30px_rgba(20,184,166,0.2)] px-8 py-4 text-lg uppercase rounded-2xl flex items-center justify-center gap-2 cursor-pointer transition-all duration-300 hover:scale-[1.03]" data-id="element-38">
                  <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-39">
                    QUIERO EL MÉTODO <ArrowRight size={20} data-id="element-40" />
                  </span>
                </button>

                <p className="mt-4 text-xs text-gray-500" data-id="element-41">
                  Descarga inmediata • Acceso de por vida
                </p>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}